/*
 * Project: BKN_FRONT
 * Copyright (c) 2024 Nttdata
 */
import axiosInstance from "../utils/axiosInstance";

export function postDownloadDocument(data, id) {
  return axiosInstance
    .post(`requeriment/download/${id}`, data, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },

    })
    .then((res) => {
      return res.data;
    })
    .catch((ex) => {
      console.log("error al descarregar el document ->",ex);
      throw ex;
    });
}
